import { useSelector, useDispatch } from "react-redux";
import { RootState } from '../../../redux/redux-store';
import { ProfileAvatar } from '../../avatar/profile-avatar';
import { Building, LogOut } from 'lucide-react';
import { signOut } from '../../../redux/user/user.async-thunks';
import { useNavigate } from 'react-router-dom';
import { getUserStateActiveClient } from "src/redux/user/user.selectors";

const UserDetails = () => {
  const userState = useSelector((state: RootState) => state.userState);
  const activeClient = useSelector(getUserStateActiveClient);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <div className="relative max-w-full px-4 sm:px-6 lg:px-8">
      <div className="mb-8 sm:mb-12">
        <div className="flex flex-col sm:flex-row items-center justify-center rounded-2xl bg-white shadow-md p-4 sm:p-8 gap-4 sm:gap-6">
          <div className="bg-gray-100 rounded-full mx-auto">
            <ProfileAvatar largerSize />
          </div>
          <div className="flex flex-col flex-1 min-w-0 items-center sm:items-start text-center sm:text-left">
            {userState.fullname && userState.fullname !== 'None None' ? (
              <>
                <div className="text-lg font-bold truncate">
                  {userState.fullname}
                </div>
                <div className="text-base truncate">
                  {userState.email}
                </div>
              </>
            ) : (
              <div className="text-lg font-bold truncate">
                {userState.email}
              </div>
            )}
            <div className="flex items-center justify-center gap-1 mt-3 text-gray-700 text-base">
              <Building className="size-4 mb-1" />
              <span className="align-middle font-medium">
                Organization:
              </span>
              <span className="truncate align-middle">
                {userState.organization?.name || activeClient?.title || '—'}
              </span>
            </div>
            <button
              className="flex items-center justify-center gap-1 mt-3 text-sm font-medium text-black/50 hover:text-black transition"
              onClick={async() => {
                await dispatch(signOut() as any);
                navigate('/login');
              }}
              type="button"
            >
              <LogOut className="size-4" />
              Log out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
